import React from 'react';

import classNames from 'classnames';

import styles from './ToolTip.module.css';

type ToolTipProps = {
   children: React.ReactNode;
   content: string;
   classNames?: { wrapper?: string; content?: string };
   visible?: boolean;
   variant?: 'right' | 'left' | 'top' | 'bottom';
};

const ToolTip = ({
   children,
   content,
   classNames: toolTipClassNames,
   visible,
   variant,
}: ToolTipProps) => {
   return (
      <div
         className={classNames(
            styles.toolTipWrapper,
            { [styles.visible]: visible },
            toolTipClassNames?.wrapper,
         )}
      >
         {children}
         <div
            className={classNames(styles.toolTipContent, toolTipClassNames?.content, {
               [styles.visible]: visible,
               [styles.right]: variant === 'right',
               [styles.left]: variant === 'left',
               [styles.top]: variant === 'top',
               [styles.bottom]: variant === 'bottom',
            })}
         >
            {content}
         </div>
      </div>
   );
};

export default ToolTip;
